import styled from "styled-components";
import { valueBearing } from "utils/validation";
import { addIcon } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var Trend = styled.span.withConfig({
  displayName: "measurementTrendArrow__Trend",
  componentId: "sc-fzyytg-0"
})(["&:before{", " opacity:.99;font-size:1.8rem;}"], function (_ref) {
  var theme = _ref.theme,
    trendIcon = _ref.trendIcon;
  return trendIcon ? addIcon(theme, trendIcon, "auto 0 auto 10px") : "";
});
export default function measurementTrendArrow(trendFromPrevious) {
  if (!valueBearing(trendFromPrevious)) return null;
  var ariaPartial = trendFromPrevious === 0 ? "samma som" : trendFromPrevious > 0 ? "bättre än" : "sämre än";
  var ariaLabel = "V\xE4rdet \xE4r ".concat(ariaPartial, " det f\xF6reg\xE5ende v\xE4rdet.");
  var trendIcon = trendFromPrevious === 0 ? "trendSame" : trendFromPrevious > 0 ? "trendUp" : "trendDown";
  return /*#__PURE__*/_jsx("span", {
    title: ariaLabel,
    children: /*#__PURE__*/_jsx(Trend, {
      "aria-label": ariaLabel,
      trendIcon: trendIcon
    })
  });
}